// @flow

import React from 'react';
import styled, { withTheme } from 'styled-components';
import ListContainer from '../../list';
import { SEMIBOLD } from '../../../helpers/fontWeight';
import Divider from '../../divider';
import type { PackageContainee } from '../../../types/pdb';
import type { Theme } from '../../../types';
import type { ListItem } from '../../list/types';

const StyledList = styled<typeof ListContainer, Theme>(ListContainer)`
  color: inherit;
`;

const Title = styled<any, Theme>('h2')`
  font-size: ${props => props.theme.package.highlights.titleFontSize};
  font-weight: ${SEMIBOLD};
  margin: 0 0 1rem;
`;

export type Props = {|
  items: Array<PackageContainee>,
  title: string,
  theme: Theme,
|};

const HighLights = ({
  items,
  title,
  theme,
}: Props) => {
  const listItems: Array<ListItem> = items.map(item => ({ icon: 'plus', usp: item.name, url: null }));

  return (items.length > 0
    ? (
      <>
        <Divider
          marginTop=".75rem"
          marginBottom=".75rem"
          width="100%"
          key="divider"
        />
        <Title key="title">
          {title}
        </Title>
        <StyledList
          compact
          key="list"
          listStyle="icons"
          iconColor={theme.package.highlights.iconColor}
          items={listItems}
        />
      </>
    )
    : null
  );
};
export default withTheme(HighLights);
